// src/util/initSentry.ts
import * as Sentry from '@sentry/react';
import getConfig from '@src/util/getConfig';
import packageJson from '../../package.json';

export const initializeSentry = () => {
    if (typeof window !== 'undefined' && window.location.hostname === 'localhost') return;

    const existingClient = Sentry.getClient();
    if (existingClient) return;

    const config = getConfig();
    const SENTRY_DSN = config?.sentry_dsn;
    const ENV_NAME = config?.env_name;

    if (!SENTRY_DSN) return;
    if (!ENV_NAME) return;

    const isProduction = ENV_NAME.toLowerCase().includes('prod');
    const APP_VERSION = packageJson?.version || '0.1.0';

    Sentry.init({
        dsn: SENTRY_DSN,
        environment: ENV_NAME,
        release: `guardian-frontend@${APP_VERSION}`,
        integrations: [
            Sentry.httpClientIntegration({
                failedRequestStatusCodes: [[400, 599]],
            }),
            Sentry.replayIntegration({
                maskAllText: isProduction,
                blockAllMedia: false,
            }),
        ],
        tracesSampleRate: 1.0,
        autoSessionTracking: true,
        tracePropagationTargets: [/^\//],
        replaysSessionSampleRate: 1.0,
        replaysOnErrorSampleRate: 1.0,
    });
};
